import { takeLatest, put, all, call } from 'redux-saga/effects'
import apiService from '../../service/apiService'
import { CREATE_SESSION_FAILURE, CREATE_SESSION_REQUEST, CREATE_SESSION_SUCCESS, GET_ALLOCATION_REQUEST, GET_ALLOCATION_SUCCESS, GET_ANNUAL_PERFORMANCE_CHART_REQUEST, GET_ANNUAL_PERFORMANCE_CHART_SUCCESS, GET_BENCHMARK_PORTFOLIO_REQUEST, GET_BENCHMARK_PORTFOLIO_SUCCESS, GET_CLASS_TEAMS_REQUEST, GET_CLASS_TEAMS_SUCCESS, GET_DAILY_RETURNS_CHART_REQUEST, GET_DAILY_RETURNS_CHART_SUCCESS, GET_DAILY_VALUES_CHART_REQUEST, GET_DAILY_VALUES_CHART_SUCCESS, GET_INSTRUMENTS_RETURNS_CHART_REQUEST, GET_INSTRUMENTS_RETURNS_CHART_SUCCESS, GET_OVERALL_RETURNS_CHART_REQUEST, GET_OVERALL_RETURNS_CHART_SUCCESS, GET_PORTFOLIO_COMPARE_CHART_REQUEST, GET_PORTFOLIO_COMPARE_CHART_SUCCESS, GET_PORTFOLIO_PERFORMANCE_CHART_REQUEST, GET_PORTFOLIO_PERFORMANCE_CHART_SUCCESS, GET_PORTFOLIO_VALUES_CHART_REQUEST, GET_PORTFOLIO_VALUES_CHART_SUCCESS, GET_SCENARIOS_BY_TYPE_REQUEST, GET_SCENARIOS_BY_TYPE_SUCCESS, GET_SCENARIOS_REQUEST, GET_SCENARIOS_SUCCESS, GET_SCENARIO_PREVIEW_REQUEST, GET_SCENARIO_PREVIEW_SUCCESS, GET_SESSION_REQUEST, GET_SESSION_SUCCESS, GET_SHARPE_RATIO_COMPARE_CHART_REQUEST, GET_SHARPE_RATIO_COMPARE_CHART_SUCCESS, GET_CLASSES_REQUEST, GET_CLASSES_SUCCESS, GET_TRAINER_GAMES_REQUEST, GET_TRAINER_GAMES_SUCCESS, NEXT_STAGE_SESSION_REQUEST, NEXT_STAGE_SESSION_SUCCESS, SET_FAVOURITE_SCENARIO_REQUEST, SET_FAVOURITE_SCENARIO_SUCCESS, START_SESSION_FAILURE, START_SESSION_REQUEST, START_SESSION_SUCCESS, GET_TRAINER_CLASSES_REQUEST, GET_TRAINER_CLASSES_SUCCESS, PAUSE_SESSION_SUCCESS, PAUSE_SESSION_REQUEST, STOP_SESSION_SUCCESS, STOP_SESSION_REQUEST, GET_TEAMS_SESSION_REQUEST, GET_TEAMS_SESSION_SUCCESS, GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_REQUEST, GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_SUCCESS, GET_PORTFOLIO_VALUES_CHART_PREVIEW_REQUEST, GET_PORTFOLIO_VALUES_CHART_PREVIEW_SUCCESS, GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_REQUEST, GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_SUCCESS, GET_PORTFOLIO_COMPARE_CHART_PREVIEW_REQUEST, GET_PORTFOLIO_COMPARE_CHART_PREVIEW_SUCCESS } from './trainer.constants'

// GET TRAINER'S GAMES
export function* getTrainerGames({ payload }) {
    const { paramList } = payload
    const { data: { count, next, previous, results } } = yield call(apiService.getTrainerGames, paramList)
    yield put({
        type: GET_TRAINER_GAMES_SUCCESS,
        payload: { count, next, previous, results }
    })
}

export function* getTrainerGamesWatcher() {
    yield takeLatest(GET_TRAINER_GAMES_REQUEST, getTrainerGames)
}

// GET SCENARIOS
export function* getScenarios({ payload }) {
    const { paramList } = payload
    const { data: { count, next, previous, results } } = yield call(apiService.getScenarios, paramList)
    yield put({
        type: GET_SCENARIOS_SUCCESS,
        payload: { count, next, previous, results }
    })
}

export function* getScenariosWatcher() {
    yield takeLatest(GET_SCENARIOS_REQUEST, getScenarios)
}

// GET CLASSES
export function* getClasses({ payload }) {
    const { data } = yield call(apiService.getClasses, payload)
    yield put({
        type: GET_CLASSES_SUCCESS,
        payload: data
    })
}

export function* getClassesWatcher() {
    yield takeLatest(GET_CLASSES_REQUEST, getClasses)
}

// GET TRAINER CLASSES
export function* getTrainerClasses({ payload }) {
    const { data } = yield call(apiService.getTrainerClasses, payload)
    yield put({
        type: GET_TRAINER_CLASSES_SUCCESS,
        payload: data
    })
}

export function* getTrainerClassesWatcher() {
    yield takeLatest(GET_TRAINER_CLASSES_REQUEST, getTrainerClasses)
}

// GET TEAMS FOR A CLASS
export function* getClassTeams({ payload }) {
    const classId = payload
    const { data } = yield call(apiService.getClassTeams, classId)
    yield put({
        type: GET_CLASS_TEAMS_SUCCESS,
        payload: data
    })
}

export function* getClassTeamsWatcher() {
    yield takeLatest(GET_CLASS_TEAMS_REQUEST, getClassTeams)
}

// SET FAVOURITE SCENARIO
export function* setFavouriteScenario({ payload }) {
    const scenarioId = payload
    const response = yield call(apiService.setFavouriteScenario, scenarioId)
    if (response)
        yield put({
            type: SET_FAVOURITE_SCENARIO_SUCCESS,
            payload: scenarioId
        })
}

export function* setFavouriteScenarioWatcher() {
    yield takeLatest(SET_FAVOURITE_SCENARIO_REQUEST, setFavouriteScenario)
}

// GET SCENARIOS BY TYPE
export function* getScenariosByType({ payload }) {
    const profile = payload
    const { data } = yield call(apiService.getScenariosByType, profile)
    yield put({
        type: GET_SCENARIOS_BY_TYPE_SUCCESS,
        payload: data
    })
}

export function* getScenariosByTypeWatcher() {
    yield takeLatest(GET_SCENARIOS_BY_TYPE_REQUEST, getScenariosByType)
}

// CREATE SESSION
export function* createSession({ payload }) {
    const body = payload
    try {
        const { data } = yield call(apiService.createSession, body)
        yield put({
            type: CREATE_SESSION_SUCCESS,
            payload: { data, message: "Session was successfully created!" }
        })
    } catch (err) {
        var message = err.response.data.error
        if (err.message === 'Request failed with status code 500') {
            yield put({
                type: CREATE_SESSION_FAILURE,
                payload: "Please check if all required fields are filled"
            })
        } else
            yield put({
                type: CREATE_SESSION_FAILURE,
                payload: message
            })
    }
}

export function* createSessionWatcher() {
    yield takeLatest(CREATE_SESSION_REQUEST, createSession)
}

// GET SCENARIO PREVIEW
export function* getScenarioPreview({ payload }) {
    const idScenario = payload
    const { data } = yield call(apiService.getScenarioPreview, idScenario)
    yield put({
        type: GET_SCENARIO_PREVIEW_SUCCESS,
        payload: { data }
    })
}

export function* getScenarioPreviewWatcher() {
    yield takeLatest(GET_SCENARIO_PREVIEW_REQUEST, getScenarioPreview)
}

// START SESSION
export function* startSession({ payload }) {
    try {
        const response = yield call(apiService.startSession, payload)
        if (response.status === 200)
            yield put({
                type: START_SESSION_SUCCESS,
                payload: { response }
            })
    } catch (err) {
        var message
        if (err.response)
            message = err.response.data.error
        yield put({
            type: START_SESSION_FAILURE,
            payload: message
        })
    }
}

export function* startSessionWatcher() {
    yield takeLatest(START_SESSION_REQUEST, startSession)
}

// GET SESSION FOR TRAINER AND TEAM
export function* getSession({ payload }) {
    const idSession = payload
    const { data } = yield call(apiService.getSession, idSession)
    yield put({
        type: GET_SESSION_SUCCESS,
        payload: data
    })
}

export function* getSessionWatcher() {
    yield takeLatest(GET_SESSION_REQUEST, getSession)
}

// GET BENCHMARK PORTFOLIO
export function* getBenchmarkPortfolio({ payload }) {
    const idSession = payload
    const { data: { benchmark_type, max_leverage, content } } = yield call(apiService.getBenchmarkPortfolio, idSession)
    yield put({
        type: GET_BENCHMARK_PORTFOLIO_SUCCESS,
        payload: { benchmark_type, max_leverage, content }
    })
}

export function* getBenchmarkPortfolioWatcher() {
    yield takeLatest(GET_BENCHMARK_PORTFOLIO_REQUEST, getBenchmarkPortfolio)
}

// GET ALLOCATION
export function* getAllocation({ payload }) {
    const idSession = payload
    const { data: { current_period, current_stage, content } } = yield call(apiService.getAllocation, idSession)
    yield put({
        type: GET_ALLOCATION_SUCCESS,
        payload: { current_period, current_stage, content }
    })
}

export function* getAllocationWatcher() {
    yield takeLatest(GET_ALLOCATION_REQUEST, getAllocation)
}

// NEXT STAGE SESSION
export function* nextStageSession({ payload }) {
    const body = payload
    const response = yield call(apiService.nextStageSession, body)
    yield put({
        type: NEXT_STAGE_SESSION_SUCCESS,
        payload: response
    })
}

export function* nextStageSessionWatcher() {
    yield takeLatest(NEXT_STAGE_SESSION_REQUEST, nextStageSession)
}

// GET PORTFOLIO COMPARE CHART
export function* getPortfolioCompareChart({ payload }) {
    const { sessionId, periodNumber } = payload
    const { data } = yield call(apiService.getPortfolioCompareChart, sessionId, periodNumber)
    yield put({
        type: GET_PORTFOLIO_COMPARE_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getPortfolioCompareChartWatcher() {
    yield takeLatest(GET_PORTFOLIO_COMPARE_CHART_REQUEST, getPortfolioCompareChart)
}

// GET INSTRUMENTS RETURNS CHART
export function* getInstrumentsReturnsChart({ payload }) {
    const { sessionId, periodNumber } = payload
    const { data } = yield call(apiService.getInstrumentsReturnsChart, sessionId, periodNumber)
    yield put({
        type: GET_INSTRUMENTS_RETURNS_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getInstrumentsReturnsChartWatcher() {
    yield takeLatest(GET_INSTRUMENTS_RETURNS_CHART_REQUEST, getInstrumentsReturnsChart)
}

// GET PORTFOLIO VALUES CHART
export function* getPortfolioValuesChart({ payload }) {
    const { sessionId, periodNumber } = payload
    const { data } = yield call(apiService.getPortfolioValuesChart, sessionId, periodNumber)
    yield put({
        type: GET_PORTFOLIO_VALUES_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getPortfolioValuesChartWatcher() {
    yield takeLatest(GET_PORTFOLIO_VALUES_CHART_REQUEST, getPortfolioValuesChart)
}

// GET PORTFOLIO PERFORMANCE CHART
export function* getPortfolioPerformanceChart({ payload }) {
    const { sessionId, periodNumber } = payload
    const { data } = yield call(apiService.getPortfolioPerformanceChart, sessionId, periodNumber)
    yield put({
        type: GET_PORTFOLIO_PERFORMANCE_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getPortfolioPerformanceChartWatcher() {
    yield takeLatest(GET_PORTFOLIO_PERFORMANCE_CHART_REQUEST, getPortfolioPerformanceChart)
}

// GET DAILY VALUES CHART
export function* getDailyValuesChart({ payload }) {
    const sessionId = payload
    const { data } = yield call(apiService.getDailyValuesChart, sessionId)
    yield put({
        type: GET_DAILY_VALUES_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getDailyValuesChartWatcher() {
    yield takeLatest(GET_DAILY_VALUES_CHART_REQUEST, getDailyValuesChart)
}

// GET DAILY RETURNS CHART
export function* getDailyReturnsChart({ payload }) {
    const sessionId = payload
    const { data } = yield call(apiService.getDailyReturnsChart, sessionId)
    yield put({
        type: GET_DAILY_RETURNS_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getDailyReturnsChartWatcher() {
    yield takeLatest(GET_DAILY_RETURNS_CHART_REQUEST, getDailyReturnsChart)
}

// GET OVERALL RETURNS CHART
export function* getOverallReturnsChart({ payload }) {
    const sessionId = payload
    const { data } = yield call(apiService.getOverallReturnsChart, sessionId)
    yield put({
        type: GET_OVERALL_RETURNS_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getOverallReturnsChartWatcher() {
    yield takeLatest(GET_OVERALL_RETURNS_CHART_REQUEST, getOverallReturnsChart)
}

// GET ANNUAL PERFORMANCE CHART
export function* getAnnualPerformanceChart({ payload }) {
    const sessionId = payload
    const { data } = yield call(apiService.getAnnualPerformanceChart, sessionId)
    yield put({
        type: GET_ANNUAL_PERFORMANCE_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getAnnualPerformanceChartWatcher() {
    yield takeLatest(GET_ANNUAL_PERFORMANCE_CHART_REQUEST, getAnnualPerformanceChart)
}

// GET SHARPE RATIO COMPARE CHART
export function* getSharpeRatioCompareChart({ payload }) {
    const sessionId = payload
    const { data } = yield call(apiService.getSharpeRatioCompareChart, sessionId)
    yield put({
        type: GET_SHARPE_RATIO_COMPARE_CHART_SUCCESS,
        payload: { data }
    })
}

export function* getSharpeRatioCompareChartWatcher() {
    yield takeLatest(GET_SHARPE_RATIO_COMPARE_CHART_REQUEST, getSharpeRatioCompareChart)
}

// PAUSE SESSION
export function* pauseSession({ payload }) {
    const body = payload
    const response = yield call(apiService.pauseSession, body)
    yield put({
        type: PAUSE_SESSION_SUCCESS,
        payload: response
    })
}

export function* pauseSessionWatcher() {
    yield takeLatest(PAUSE_SESSION_REQUEST, pauseSession)
}

// STOP SESSION
export function* stopSession({ payload }) {
    const body = payload
    const response = yield call(apiService.stopSession, body)
    yield put({
        type: STOP_SESSION_SUCCESS,
        payload: response
    })
}

export function* stopSessionWatcher() {
    yield takeLatest(STOP_SESSION_REQUEST, stopSession)
}

// GET TEAMS SESSION
export function* getTeamsSession({ payload }) {
    const { sessionId, periodNumber } = payload
    const { data } = yield call(apiService.getTeamsSession, sessionId, periodNumber)
    yield put({
        type: GET_TEAMS_SESSION_SUCCESS,
        payload: { data }
    })
}

export function* getTeamsSessionWatcher() {
    yield takeLatest(GET_TEAMS_SESSION_REQUEST, getTeamsSession)
}

// GET PORTFOLIO COMPARE CHART PREVIEW
export function* getPortfolioCompareChartPreview({ payload }) {
    const scenarioId = payload
    const { data } = yield call(apiService.getPortfolioCompareChartPreview, scenarioId)
    yield put({
        type: GET_PORTFOLIO_COMPARE_CHART_PREVIEW_SUCCESS,
        payload: { data }
    })
}

export function* getPortfolioCompareChartPreviewWatcher() {
    yield takeLatest(GET_PORTFOLIO_COMPARE_CHART_PREVIEW_REQUEST, getPortfolioCompareChartPreview)
}

// GET INSTRUMENTS RETURNS CHART PREVIEW
export function* getInstrumentsReturnsChartPreview({ payload }) {
    const scenarioId = payload
    const { data } = yield call(apiService.getInstrumentsReturnsChartPreview, scenarioId)
    yield put({
        type: GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_SUCCESS,
        payload: { data }
    })
}

export function* getInstrumentsReturnsChartPreviewWatcher() {
    yield takeLatest(GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_REQUEST, getInstrumentsReturnsChartPreview)
}

// GET PORTFOLIO VALUES CHART PREVIEW
export function* getPortfolioValuesChartPreview({ payload }) {
    const scenarioId = payload
    const { data } = yield call(apiService.getPortfolioValuesChartPreview, scenarioId)
    yield put({
        type: GET_PORTFOLIO_VALUES_CHART_PREVIEW_SUCCESS,
        payload: { data }
    })
}

export function* getPortfolioValuesChartPreviewWatcher() {
    yield takeLatest(GET_PORTFOLIO_VALUES_CHART_PREVIEW_REQUEST, getPortfolioValuesChartPreview)
}

// GET PORTFOLIO PERFORMANCE CHART PREVIEW
export function* getPortfolioPerformanceChartPreview({ payload }) {
    const scenarioId = payload
    const { data } = yield call(apiService.getPortfolioPerformanceChartPreview, scenarioId)
    yield put({
        type: GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_SUCCESS,
        payload: { data }
    })
}

export function* getPortfolioPerformanceChartPreviewWatcher() {
    yield takeLatest(GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_REQUEST, getPortfolioPerformanceChartPreview)
}

export function* trainerSaga() {
    yield all([call(getTrainerGamesWatcher), call(getScenariosWatcher), call(getClassesWatcher), call(getTrainerClassesWatcher), call(getClassTeamsWatcher), call(setFavouriteScenarioWatcher), call(getScenariosByTypeWatcher), call(createSessionWatcher), call(getScenarioPreviewWatcher), call(startSessionWatcher), call(getSessionWatcher), call(getBenchmarkPortfolioWatcher), call(getAllocationWatcher), call(nextStageSessionWatcher), call(getPortfolioCompareChartWatcher), call(getInstrumentsReturnsChartWatcher), call(getPortfolioValuesChartWatcher), call(getPortfolioPerformanceChartWatcher), call(getDailyValuesChartWatcher), call(getDailyReturnsChartWatcher), call(getOverallReturnsChartWatcher), call(getAnnualPerformanceChartWatcher), call(getSharpeRatioCompareChartWatcher), call(pauseSessionWatcher), call(stopSessionWatcher), call(getTeamsSessionWatcher), call(getPortfolioCompareChartPreviewWatcher), call(getInstrumentsReturnsChartPreviewWatcher), call(getPortfolioValuesChartPreviewWatcher), call(getPortfolioPerformanceChartPreviewWatcher)])
}